// extracted by mini-css-extract-plugin
export default {"btnKnowMore":"ComponentMainButton_btnKnowMore__36pu7","emptyBlock":"ComponentMainButton_emptyBlock__v03rp","deerIcon":"ComponentMainButton_deerIcon__1xVgb"};